import { useCallback } from "react";
import { useRecoilCallback, useRecoilState } from "recoil";
import { BoardCellAtomFamily, CurrentBoardAtom, WorkingBoardAtom } from "../utils/context";
export function useBoard() {
    var _a = useRecoilState(CurrentBoardAtom), currentBoard = _a[0], setCurrentBoard = _a[1];
    var _b = useRecoilState(WorkingBoardAtom), workingBoard = _b[0], setWorkingBoard = _b[1];
    var resetBoard = useRecoilCallback(function (_a) {
        var set = _a.set;
        return function (matrix) {
            matrix.metaMatrix.all().forEach(function (location) {
                var _a;
                set(BoardCellAtomFamily(location.index), (_a = matrix.at(location.index)) !== null && _a !== void 0 ? _a : 'empty');
            });
            setWorkingBoard(matrix);
            setCurrentBoard(matrix);
        };
    }, [setWorkingBoard, setCurrentBoard]);
    var updateCurrentBoard = useCallback(function () {
        setCurrentBoard(workingBoard);
    }, [setCurrentBoard, workingBoard]);
    var getBoardLine = useCallback(function (lineType, index) {
        return lineType === "row"
            ? currentBoard.getRow(index)
            : currentBoard.getCol(index);
    }, [currentBoard]);
    return {
        resetBoard: resetBoard,
        currentBoard: currentBoard,
        workingBoard: workingBoard,
        updateCurrentBoard: updateCurrentBoard,
        getLine: getBoardLine
    };
}
